import { defineMessages } from 'react-intl'

export const scope = 'app.components.ScheduledChatMessageTable'

/*
 * ScheduledChatMessageTable Messages
 *
 * This contains all the text for the ScheduledChatMessageTable component.
 */
export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the ScheduledChatMessageTable component!',
  },
  tableHeaderOne: {
    id: `${scope}.tableHeaderOne`,
    defaultMessage: 'Name',
  },
  tableHeaderTwo: {
    id: `${scope}.tableHeaderOne`,
    defaultMessage: 'Start Date',
  },
  tableHeaderThree: {
    id: `${scope}.tableHeaderTwo`,
    defaultMessage: 'Time',
  },
  tableHeaderFour: {
    id: `${scope}.tableHeaderThree`,
    defaultMessage: 'Schedule Description',
  },
})
